module.exports = __webpack_public_path__ + "img/9d69b28.png";